import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailHostingComponent from "../../../components/Customer/hostings/DetailHostingComponent";

const DetailHostingPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <DetailHostingComponent
        hostingId={ params.hostingId }
        redirectBack={ () => redirectBack() }
    />;
}

export default DetailHostingPage;